import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const saveApplePayDeliveryInstructionCustom: CheckoutActionCreator = (
  deliveryInstructionCustom: string,
) => ({
  type: actionTypes.SAVE_APPLE_PAY_DELIVERY_INSTRUCTION_CUSTOM,
  deliveryInstructionCustom,
})
